import { toast } from 'react-toastify';
import { SAVE_IN_PROGRESS, SAVE_PROCESS_DONE } from "./fetchingDataActions";
import { GlobalLookUpDTO } from './DTOs/GlobalLookUpDTO';
import { createItemWs, updateItemWs } from '../webservices/saveWS';
import { fetchItemsWS } from '../webservices/fetchWS';
import { translateQnaireWs } from '../webservices/translateQnaireWS';
import { createTranslationRequest, TRANSLATION_MODES } from '../constants/translations';


export const FETCHING_GLOBAL_LOOKUPS_ACTION = 'FETCHING_GLOBAL_LOOKUPS_ACTION';
export const FETCH_GLOBAL_LOOKUPS_SUCCESS_ACTION = 'FETCH_GLOBAL_LOOKUPS_SUCCESS_ACTION';
export const FETCH_GLOBAL_LOOKUPS_ERROR_ACTION = 'FETCH_GLOBAL_LOOKUPS_ERROR_ACTION';

export const GLOBAL_LOOKUP_ADD_ACTION = 'GLOBAL_LOOKUP_ADD_ACTION';
export const GLOBAL_LOOKUP_EDIT_ACTION = 'GLOBAL_LOOKUP_EDIT_ACTION';
export const GLOBAL_LOOKUP_DELETE_ACTION = 'GLOBAL_LOOKUP_DELETE_ACTION';


export const fetchGlobalLookupsAction = (tenant) => {
  const queryParams = {
    PK: `${tenant.id}%23LOOKUPS`,
    SK: 'LOOKUP%23',
  };

  return (dispatch, getState) => {
    fetchItemsWS('get-dynamodb', queryParams, getState)
      .then((result) => {
        const returnItems = result.Items.filter(item => item.op !== 'd');
        dispatch({ type: FETCH_GLOBAL_LOOKUPS_SUCCESS_ACTION, payload: returnItems });
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: FETCH_GLOBAL_LOOKUPS_ERROR_ACTION, err });
      });
  };
}

export const globalLookupSaveAction = (lookup, tenantId) => {
  return (dispatch, getState) => {
    const saveObject = new GlobalLookUpDTO(lookup, tenantId);
    dispatch({ type: SAVE_IN_PROGRESS });
    if (lookup.id === undefined) {
      saveObject.status = 'active'
      saveObject.values = [];
      createItemWs(saveObject, getState)
        .then((result) => {
          dispatch({ type: GLOBAL_LOOKUP_ADD_ACTION, payload: result.data });
          dispatch({ type: SAVE_PROCESS_DONE });
          toast.success('The lookup item has been added successfully');
        })
        .catch((err) => {
          console.log(err);
          dispatch({ type: SAVE_PROCESS_DONE });
          toast.error('Failed to add lookup item please try again');
        })
    }
    else {
      updateItemWs(saveObject, getState)
        .then((result) => {
          dispatch({ type: GLOBAL_LOOKUP_EDIT_ACTION, payload: result.data });
          dispatch({ type: SAVE_PROCESS_DONE });
          toast.success('The lookup item has been updated successfully');
        })
        .catch((err) => {
          console.log(err);
          dispatch({ type: SAVE_PROCESS_DONE });
          toast.error('Failed to update lookup item please try again');
        })
    }
  }
}

export const globalLookupDeleteAction = (lookup) => {
  return (dispatch, getState) => {
    const saveObject = new GlobalLookUpDTO(lookup);
    saveObject.status = 'isDeleted';
    updateItemWs(saveObject, getState)
      .then((result) => {
        dispatch({ type: GLOBAL_LOOKUP_DELETE_ACTION, payload: result.data.id });
        dispatch({ type: SAVE_PROCESS_DONE });
        toast.success('The lookup item has been deleted successfully');
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: SAVE_PROCESS_DONE });
        toast.error('Failed to delete lookup item please try again');
      })
  }
}

export const translateLookupAction = (lookup,tenantId, translationMode = TRANSLATION_MODES.ADDITIVE) => {
  return async (dispatch, getState) => {
    const translatingLookup = {
      ...lookup,
      tenantId: lookup.tenantId || tenantId,
      status: "translating"
    };

    // Lock the lookup in the current client before the request starts. The
    // translation workflow remains responsible for persisting this status.
    dispatch({
      type: GLOBAL_LOOKUP_EDIT_ACTION,
      payload: translatingLookup
    });

    try {
      const result = await translateQnaireWs(
        createTranslationRequest(lookup, translationMode),
        getState
      );
      toast.success('Lookup translation started. The lookup will be unavailable until the translation is complete.');
      return result;
    } catch (err) {
      toast.error('Failed to translate lookup please try again');
      console.log(err);
      // The workflow was not acknowledged, so restore the client-side status.
      dispatch({ type: GLOBAL_LOOKUP_EDIT_ACTION, payload: lookup });
      dispatch({ type: FETCH_GLOBAL_LOOKUPS_ERROR_ACTION, err });
      throw err;
    }
  }
}
